/** Duck-typed: bundling can give `TRPCClientError` another class identity across modules. */
export function isUnauthorizedError(error: unknown): boolean {
	if (typeof error !== 'object' || error == null) return false;
	const data = (error as { data?: { code?: unknown } }).data;
	return typeof data === 'object' && data != null && data.code === 'UNAUTHORIZED';
}

const NGOS_PREFIX = '/ngos';

/** Portal-relative (`/dashboard`), without the internal `/ngos` prefix, as `auth.callback.ts` and `select-ngo.tsx` expect. */
export function ngoLoginRedirectPath(pathname: string): string | undefined {
	const relative = pathname.startsWith(NGOS_PREFIX) ? pathname.slice(NGOS_PREFIX.length) : pathname;
	return relative && relative !== '/' ? relative : undefined;
}
